import { Dropdown } from "../utils/dropdown";

const navCategoryNoDropdown = document.querySelectorAll(
  ".main-menu__nav__category:not([data-menu-id])",
);
const parent = document.querySelector(".main-menu__dropdowns");
const overlayBackground = document.querySelector(".site-wrap__overlay");

document.querySelectorAll(".main-menu__dropdown").forEach((el) => {
  const id = el.id;
  const trigger = document.querySelector(`[data-menu-id="${id}"]`);
  if (!trigger) return;

  new Dropdown(el, {
    trigger,
    displayEvent: "mouseover",
    toggledClass: "is-open",
    hideDelay: null,
    mouseLeaveDelay: 1,
    showCallback() {
      el.classList.remove("is-closing");
      document.querySelectorAll(".main-menu__dropdown").forEach((s) => {
        if (s !== el) s.classList.remove("is-closing");
      });
      parent?.classList.add("is-open");
      trigger.classList.add("is-open");
      overlayBackground?.classList.add("is-open");
    },
    hideCallback() {
      parent?.classList.remove("is-open");
      trigger.classList.remove("is-open");
      if (!parent?.classList.contains("is-open")) {
        el.classList.add("is-closing");
        overlayBackground?.classList.remove("is-open");
      }
    },
  });
});

navCategoryNoDropdown.forEach((cat) => {
  cat.addEventListener("mouseover", () => Dropdown._active?.hide());
});
